import { useTranslation } from 'react-i18next'
import SiteLayout from '@/components/feature/SiteLayout'
import PageHeader from '@/components/feature/PageHeader'
import ServicesSeo from '@/components/feature/ServicesSeo'
import ServicesSection from '@/components/feature/sections/ServicesSection'
import PackagesSection from '@/components/feature/sections/PackagesSection'
import ProcessSection from '@/components/feature/sections/ProcessSection'
import FaqSection from '@/components/feature/sections/FaqSection'
import CtaBand from '@/components/feature/CtaBand'

export default function Services() {
  const { t } = useTranslation()

  return (
    <SiteLayout>
      <ServicesSeo />
      <PageHeader
        breadcrumb={t('pages.services.breadcrumb')}
        label={t('pages.services.label')}
        title={t('pages.services.title')}
        description={t('pages.services.description')}
        image="https://readdy.ai/api/search-image?query=professional%20photographer%20holding%20a%20camera%20during%20a%20golden%20hour%20wedding%20shoot%2C%20warm%20sunlight%20and%20soft%20bokeh%2C%20cinematic%20behind%20the%20scenes%20photography%2C%20rich%20amber%20and%20brown%20tones%2C%20premium%20editorial%20mood&width=1920&height=900&seq=shabi-hdr-services&orientation=landscape"
        imageAlt="Shabi Media photographer at a golden hour wedding shoot"
      />
      <ServicesSection />
      <PackagesSection />
      <ProcessSection />
      <FaqSection />
      <CtaBand
        eyebrow={t('cta.services.eyebrow')}
        title={t('cta.services.title')}
        description={t('cta.services.description')}
      />
    </SiteLayout>
  )
}